import TuneIcon from '@mui/icons-material/Tune';
import {
  Box,
  Fab,
  useMediaQuery
} from '@mui/material';
import { FC, useEffect, useState } from 'react';
import { useNavigate, useParams, useSearchParams } from 'react-router-dom';
import { getCurrentDate, isDisciplineOption } from '../../../../utils/format';
import { CourseFilter } from '../../services/type';
import useGetCourses from '../../services/use-get-courses';
import List from '../List';
import CourseHeader from './CourseHeader';
import CourseFilters from './filters/CourseFilters';
import DialogMobileFilter from './filters/DialogMobileFilter';

const CoursesPage: FC = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const { date } = useParams<{ date: string }>();
  const initialDate = date ?? getCurrentDate();
  const [selectedDate, setSelectedDate] = useState(initialDate);
  const [filters, setFilters] = useState<CourseFilter>({});
  const { data: program } = useGetCourses(selectedDate);
  const isMobile = useMediaQuery((theme) => theme.breakpoints.down('md'));
  const [isMobileRaceOpen, setIsMobileRaceOpen] = useState(false);

  if (date === undefined) {
    setSelectedDate(getCurrentDate());
  }

  useEffect(() => {
    const nextFilters: CourseFilter = {};

    const reunion = searchParams.get('reunion');
    if (reunion) {
      nextFilters.reunion = Number(reunion);
    }

    const discipline = searchParams.get('discipline');
    if (discipline && isDisciplineOption(discipline)) {
      nextFilters.discipline = discipline;
    }

    const minParticipant = searchParams.get('minParticipant');
    if (minParticipant) {
      nextFilters.minParticipant = Number(minParticipant);
    }

    const maxParticipant = searchParams.get('maxParticipant');
    if (maxParticipant) {
      nextFilters.maxParticipant = Number(maxParticipant);
    }

    setFilters(nextFilters);
  }, [searchParams]);

  const handleDateChange = (newDate: string) => {
    setSelectedDate(newDate);
    setFilters({});
    navigate(`/courses/${newDate}`, { replace: true });
  };

  const handleOpenDialog = () => {
    setIsMobileRaceOpen(!isMobileRaceOpen);
  };

  return isMobile ? (
    <Box display={'flex'} flexDirection={'column'} gap={2} width={'100%'} mt={1}>
      <Fab
        size="medium"
        color="primary"
        sx={{ position: 'absolute', bottom: 10, right: 20 }}
        onClick={handleOpenDialog}
      >
        <TuneIcon />
      </Fab>
      <DialogMobileFilter
        filters={filters}
        handleDateChange={handleDateChange}
        handleOpenDialog={handleOpenDialog}
        isMobileRaceOpen={isMobileRaceOpen}
        selectedDate={selectedDate}
        setFilters={setFilters}
        programme={program}
      />

      <List program={program} filter={filters} />
    </Box>
  ) : (
    <Box
      display={'flex'}
      flexDirection={'row'}
      width={'80%'}
      justifyContent={'center'}
      gap={3}
      mt={1}
    >
      <Box display={'flex'} flexDirection={'column'} width={'38%'} gap={1}>
        <CourseHeader
          selectedDate={selectedDate}
          handleDateChange={handleDateChange}
          program={program}
        />

        <CourseFilters
          filter={filters}
          setFilter={setFilters}
          programme={program}
        />
      </Box>
      <Box display={'flex'} flexDirection={'column'} gap={2} width={'60%'}>
        <List program={program} filter={filters} />
      </Box>
    </Box>
  );
};

export default CoursesPage;
